import { useTranslation } from "@coworker/locales";
import styles from "./StateMessage.module.css";

type StateMessageType = "empty" | "error" | "noResults";

const translationKeyByType: Record<
  StateMessageType,
  { textLabel: string; testId: string }
> = {
  empty: {
    textLabel: "noDestinationTeamsAvailableString",
    testId: "move-users-to-team-empty-state",
  },
  error: {
    textLabel: "sorrySomethingWentWrongString",
    testId: "move-users-to-team-error-state",
  },
  noResults: {
    textLabel: "noResultsString",
    testId: "move-users-to-team-no-results",
  },
};

interface StateMessageProps {
  type: StateMessageType;
}

export function StateMessage({ type }: StateMessageProps) {
  const { t } = useTranslation();
  const { textLabel, testId } = translationKeyByType[type]!;
  return (
    <p className={styles["state-message"]} data-testid={testId}>
      {t(textLabel)}
    </p>
  );
}
